import toast from 'react-hot-toast';

export const handleImprimirTramite = (tramite) => {
  const printWindow = window.open('', '_blank', 'width=850,height=900');
  if (!printWindow) {
    toast.error('El navegador bloqueó la ventana emergente para imprimir. Habilite ventanas emergentes.');
    return;
  }

  const documentosRows = (tramite.documentos || []).length > 0
    ? tramite.documentos.map((doc, idx) => `
        <tr>
          <td style="padding: 10px 12px; border-bottom: 1px solid #e2e8f0; font-size: 13px; color: #475569;">${idx + 1}</td>
          <td style="padding: 10px 12px; border-bottom: 1px solid #e2e8f0; font-size: 13px; font-weight: 500; color: #1e293b;">
            ${doc.nombre_original || doc.tipo_documento || 'Documento adjunto'}
          </td>
          <td style="padding: 10px 12px; border-bottom: 1px solid #e2e8f0; font-size: 13px; color: #64748b;">
            ${doc.tipo_documento || 'Adjunto'}
          </td>
          <td style="padding: 10px 12px; border-bottom: 1px solid #e2e8f0; font-size: 13px; color: #64748b; text-align: right;">
            ${doc.created_at ? new Date(doc.created_at).toLocaleDateString('es-CL') : '-'}
          </td>
        </tr>
      `).join('')
    : `
      <tr>
        <td colspan="4" style="padding: 14px; text-align: center; color: #94a3b8; font-style: italic; font-size: 13px;">
          No hay documentos adjuntos registrados en este trámite.
        </td>
      </tr>
    `;

  const boletaRut = tramite.boleta_rut || tramite.rut_solicitante || '-';
  const boletaRazon = tramite.boleta_razon_social || tramite.nombre_solicitante || '-';
  const boletaGiro = tramite.boleta_giro || 'Particular';
  const boletaCorreo = tramite.boleta_correo || tramite.correo || '-';
  const boletaDireccion = tramite.boleta_direccion || tramite.direccion || '-';

  const html = `
    <!DOCTYPE html>
    <html lang="es">
      <head>
        <meta charset="utf-8">
        <title>Ficha Trámite ${tramite.numero_seguimiento || ''}</title>
        <style>
          @page {
            size: letter portrait;
            margin: 15mm;
          }
          body {
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
            color: #0f172a;
            margin: 0;
            padding: 30px;
            background: #fff;
            line-height: 1.45;
            font-size: 13px;
          }
          .header {
            text-align: center;
            margin-bottom: 25px;
            border-bottom: 2px solid #0f172a;
            padding-bottom: 15px;
          }
          .title {
            font-size: 20px;
            font-weight: 800;
            margin: 0 0 4px 0;
            text-transform: uppercase;
            letter-spacing: 0.8px;
            color: #0f172a;
          }
          .subtitle {
            font-size: 13px;
            color: #475569;
            text-transform: uppercase;
            font-weight: 600;
            letter-spacing: 0.5px;
          }
          .top-badge-banner {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #f8fafc;
            border: 1px solid #cbd5e1;
            border-radius: 6px;
            padding: 10px 16px;
            margin-bottom: 20px;
            font-size: 12px;
          }
          .badge-estado {
            display: inline-block;
            background: #0284c7;
            color: #fff;
            font-weight: 700;
            font-size: 11px;
            padding: 3px 10px;
            border-radius: 4px;
            text-transform: uppercase;
          }
          .section-title {
            font-size: 13px;
            font-weight: 700;
            color: #0f172a;
            text-transform: uppercase;
            margin: 20px 0 10px 0;
            border-bottom: 1px solid #cbd5e1;
            padding-bottom: 5px;
            letter-spacing: 0.5px;
          }
          .info-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 15px;
          }
          .info-table th {
            width: 25%;
            text-align: left;
            padding: 7px 10px;
            background: #f1f5f9;
            color: #334155;
            font-weight: 600;
            font-size: 12px;
            border: 1px solid #e2e8f0;
            text-transform: uppercase;
          }
          .info-table td {
            padding: 7px 10px;
            border: 1px solid #e2e8f0;
            color: #0f172a;
            font-size: 13px;
          }
          .data-table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 8px;
            margin-bottom: 20px;
          }
          .data-table th {
            text-align: left;
            padding: 9px 12px;
            background: #0f172a;
            color: #fff;
            font-size: 11px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
          .footer {
            text-align: center;
            font-size: 11px;
            color: #94a3b8;
            margin-top: 35px;
            border-top: 1px solid #e2e8f0;
            padding-top: 15px;
          }
          @media print {
            body { padding: 0; }
            .top-badge-banner { background: #fff !important; border: 1px solid #cbd5e1 !important; }
            .info-table th { background: #f1f5f9 !important; color: #0f172a !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            .data-table th { background: #e2e8f0 !important; color: #0f172a !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            .badge-estado { border: 1px solid #0284c7; color: #0284c7 !important; background: transparent !important; }
          }
        </style>
      </head>
      <body>
        <div class="header">
          <div class="title">Conservador de Bienes Raíces de San Carlos</div>
          <div class="subtitle">Carátula e Información Técnica del Trámite</div>
        </div>

        <div class="top-badge-banner">
          <div><strong>FOLIO:</strong> <span style="font-size: 14px; color: #0284c7; font-weight: 800;">${tramite.numero_seguimiento || 'S/N'}</span></div>
          <div><strong>FECHA INGRESO:</strong> ${tramite.created_at ? new Date(tramite.created_at).toLocaleString('es-CL') : '-'}</div>
          <div><span class="badge-estado">${tramite.estado?.nombre || 'Ingresado'}</span></div>
        </div>

        <div class="section-title">1. Identificación del Trámite y Solicitante</div>
        <table class="info-table">
          <tr>
            <th>Nombre Solicitante</th>
            <td><strong>${tramite.nombre_solicitante || '-'}</strong></td>
            <th>RUT Solicitante</th>
            <td><strong>${tramite.rut_solicitante || '-'}</strong></td>
          </tr>
          <tr>
            <th>Tipo Inscripción</th>
            <td>${tramite.tipo_inscripcion?.nombre || tramite.tipo_inscripcion || '-'}</td>
            <th>Área / Registro</th>
            <td>${tramite.area?.nombre || 'Propiedad'}</td>
          </tr>
          <tr>
            <th>Correo Electrónico</th>
            <td>${tramite.correo || '-'}</td>
            <th>Teléfono Contacto</th>
            <td>${tramite.telefono || '-'}</td>
          </tr>
          <tr>
            <th>Dirección</th>
            <td colspan="3">${tramite.direccion || '-'}</td>
          </tr>
        </table>

        ${(tramite.repertorios || []).length > 0 ? `
          <div class="section-title">2. Repertorios y Actos Jurídicos (${(tramite.repertorios || []).length})</div>
          <div style="margin-bottom: 15px; padding: 6px 0;">
            ${(tramite.repertorios || []).map(r => `
              <span style="display: inline-block; background: #f8fafc; border: 1px solid #cbd5e1; border-radius: 6px; padding: 6px 12px; margin-right: 8px; margin-bottom: 6px; font-size: 12px;">
                <strong style="color: #0f172a; font-size: 13px;">Repertorio #${r.numero_repertorio}</strong> 
                <span style="background: #e0f2fe; color: #0369a1; font-weight: 700; padding: 2px 8px; border-radius: 4px; margin-left: 6px; font-size: 11px;">
                  ${r.contrato?.nombre === 'Otro' ? r.contrato_otro : (r.contrato?.nombre || 'General')}
                </span>
                ${r.nombre_requirente ? `<span style="color: #64748b; margin-left: 6px; font-size: 11px;">(${r.nombre_requirente})</span>` : ''}
              </span>
            `).join('')}
          </div>
        ` : (tramite.exento_repertorio ? `
          <div class="section-title">2. Condición de Repertorio</div>
          <div style="margin-bottom: 15px; padding: 10px 14px; background: #ecfdf5; border: 1px solid #10b981; border-radius: 6px; font-size: 12px; color: #065f46;">
            <strong>🛡️ TRÁMITE INSTITUCIONALMENTE EXENTO DE REPERTORIO</strong>
            ${tramite.motivo_exento_repertorio ? ` — Motivo: <em>${tramite.motivo_exento_repertorio}</em>` : ''}
            <div style="font-size: 11px; color: #047857; margin-top: 3px;">Habilitado para cotización y despacho sin asignación de repertorio previo.</div>
          </div>
        ` : '')}

        <div class="section-title">${(tramite.repertorios || []).length > 0 ? '3' : '2'}. Datos de Facturación / Boleta</div>
        <table class="info-table">
          <tr>
            <th>RUT Boleta / Empresa</th>
            <td><strong>${boletaRut}</strong></td>
            <th>Razón Social</th>
            <td><strong>${boletaRazon}</strong></td>
          </tr>
          <tr>
            <th>Giro Comercial</th>
            <td>${boletaGiro}</td>
            <th>Correo Facturación</th>
            <td>${boletaCorreo}</td>
          </tr>
          <tr>
            <th>Dirección Tributaria</th>
            <td colspan="3">${boletaDireccion}</td>
          </tr>
        </table>

        <div class="section-title">3. Documentos Adjuntos (${(tramite.documentos || []).length})</div>
        <table class="data-table">
          <thead>
            <tr>
              <th style="width: 40px;">#</th>
              <th>Nombre del Archivo</th>
              <th>Tipo de Documento</th>
              <th style="text-align: right; width: 120px;">Fecha</th>
            </tr>
          </thead>
          <tbody>
            ${documentosRows}
          </tbody>
        </table>

        ${tramite.observaciones ? `
          <div class="section-title">4. Observaciones Generales</div>
          <div style="background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px; padding: 12px; font-size: 13px; color: #334155; font-style: italic;">
            ${tramite.observaciones}
          </div>
        ` : ''}

        <div class="footer">
          Documento oficial impreso desde el Sistema de Gestión CBR San Carlos el ${new Date().toLocaleString('es-CL')}.
        </div>

        <script>
          window.onload = function() {
            window.focus();
            window.print();
            setTimeout(function() { window.close(); }, 500);
          };
        </script>
      </body>
    </html>
  `;

  printWindow.document.write(html);
  printWindow.document.close();
};
